import { z } from 'zod'

export const staffFormSchema = z.object({
  firstName: z.string().min(1, 'staff:errors.firstNameRequired').max(100),
  middleName: z.string().max(100).optional().or(z.literal('')),
  lastName: z.string().min(1, 'staff:errors.lastNameRequired').max(100),
  egn: z.string().length(10, 'staff:errors.egnLength'),
  dateOfBirth: z.string().optional().or(z.literal('')),
  gender: z.enum(['MALE', 'FEMALE']).optional(),
  phone: z.string().min(1, 'staff:errors.phoneRequired').max(20),
  email: z.string().email().max(255).optional().or(z.literal('')),
  address: z.string().max(500).optional().or(z.literal('')),
  position: z.string().min(1, 'staff:errors.positionRequired').max(100),
  positionCategory: z.enum(['specialized', 'non_specialized', 'support', 'external'], {
    message: 'staff:errors.positionCategoryRequired',
  }),
  employmentType: z.enum(['FULL_TIME', 'PART_TIME', 'CONTRACT']),
  contractType: z.string().max(50).optional().or(z.literal('')),
  hireDate: z.string().min(1, 'staff:errors.hireDateRequired'),
  isBudgetedPosition: z.boolean(),
  notes: z.string().optional().or(z.literal('')),
})

export type StaffFormValues = z.infer<typeof staffFormSchema>

export const defaultStaffValues: StaffFormValues = {
  firstName: '',
  middleName: '',
  lastName: '',
  egn: '',
  dateOfBirth: '',
  gender: undefined,
  phone: '',
  email: '',
  address: '',
  position: '',
  positionCategory: 'specialized',
  employmentType: 'FULL_TIME',
  contractType: '',
  hireDate: new Date().toISOString().split('T')[0],
  isBudgetedPosition: true,
  notes: '',
}

export const IMMUTABLE_FIELDS = ['egn', 'hireDate'] as const
